module.exports = __webpack_public_path__ + "img/hay.52ae67b2.webp";